import React from 'react'
import content from '../../../../docs/legal/cookie-policy.md?raw'
import { MarkdownDoc } from '../../components/MarkdownDoc'

export default function Cookies() {
  return (
    <div className="legal-page">
      <MarkdownDoc content={content} />
    </div>
  )
}
